<template>
  <div id="file-import">
    <div class="container">

      <Tabs ref="tabs">

        <TabSection :title="$t('configuration')">
          <div class="columns">
            <div class="column">
              <div class="group">
                <label for="sel-process">Action</label>
                <select id="sel-process" v-model="process.selected">
                  <option :value="null"></option>
                  <option :value="p" v-for="p of process.all" :key="`p_${p.id}`">{{ p.name }}</option>
                </select>
              </div>

              <template v-if="selected">
                <div class="group" v-if="selected.fileType">
                  <label>File type</label>
                  <div>{{ selected.fileType }}</div>
                </div>
                <div class="group" v-if="selected.separator">
                  <label>Separator</label>
                  <div>{{ selected.separator }}</div>
                </div>
                <div class="group" v-if="selected.notes">
                  <label>Notes</label>
                  <div v-for="(note, i) of selected.notes" :key="`note_${i}`" v-html="`- ${note}`"></div>
                </div>
                <div class="group" v-if="selected.expectedColumns">
                  <label>Expected columns</label>
                  <div v-for="ec of selected.expectedColumns" :key="`ec_${ec.name}`">{{ ec.name }}</div>
                </div>
              </template>
            </div>

            <div class="column">
              <input v-if="fileRequired" type="file" id="file" ref="file" @change="onFileChange" />
            </div>

            <div class="column">
              <button class="btn btn-primary" @click="check">Check</button>
              <button class="btn btn-primary" @click="execute">Execute</button>
            </div>

          </div>
        </TabSection>

        <TabSection ref="dataTab" title="Logs" v-if="logs">
          <div v-if="logs.length === 0">Nothing created</div>
          <div v-for="(l, k) of logs" :key="`log_${k}`">{{ l }}</div>
        </TabSection>

      </Tabs>

    </div>
  </div>
</template>

<script>
  import { Core } from "@/core/Core";

  export default {
    name: "FileImport",

    data() {
      return {
        process: {
          selected: null,
          all: [{
            id: 'loyalty-account-balance',
            name: 'Account import',
            api: '/api/file_import',
            fileType: 'csv',
            separator: ',',
            expectedColumns: [
              { name: 'NoCarte' },
              { name: 'NomCarte' },
              { name: 'NoCompteClient' },
              { name: 'NomCompteClient' },
              { name: 'Courriel' },
              { name: 'GroupeCompteClientFra' },
              { name: 'DateDerniereTrx' },
              { name: 'MntSolde' },
            ]
          }, {
            id: 'dispatch-maitre-import',
            name: 'Dispatch customer import from maitreD file',
            api: '/api/file_import',
            fileType: 'csv',
            separator: ',',
            notes: [
              'The file used for this importation is exported from maitreD',
              'Only dispatch customers are created',
              'Existing customers are NOT updated if found',
              'To valid if you have the right file, a csv line should starts with something like: "Delivery customers list","1013","Demo","Phone number","Customer", .....'
            ],
            keepColumns: [5, 6, 9, 15],
            expectedColumns: [
              { name: 'column 6 - Phone' },
              { name: 'column 7 - Name' },
              { name: 'column 10 - Address' },
              { name: 'column 16 - Postal Code' }
            ]
          }, {
            id: 'mass-on-boarding-email',
            name: 'On boarding emails',
            api: '/api/mass_notification_task',
          }]
        },
        fileData: null,
        logs: null
      }
    },

    computed: {
      selected() {
        return this.process.selected;
      },
      fileRequired() {
        return this.selected && this.selected.fileType
      },
      branchNameCanonical() {
        let contextBranch = this.$store.state.contextBranch;
        return contextBranch ? contextBranch.nameCanonical : null;
      },
      fileToUpload() {
        if (!this.file || !this.selected) {
          return null;
        }
        if (this.selected.keepColumns === undefined) {
          return this.file;
        }
        let dataStart = this.file.indexOf(',') + 1;
        let metaData = this.file.substring(0, dataStart);

        return metaData +
          btoa(
            this.CSVToArray(atob(this.file.substring(dataStart)))
              .map(line => {
                if (line.length <= 1) { return ''; }
                return this.selected.keepColumns.map(k => `\"${line[k] || ''}\"`).join(',')
              })
              .join("\r\n")
          );
      }
    },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "advanced_navigation.file_import";
      this.$store.state.pageIcon = "/icon/settings.svg";
    },

    methods: {
      onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        let file = files[0];
        let reader = new FileReader();
        let extension = file.name.split('.').pop();
        reader.onload = e => this.tryApplyFile(e.target.result, extension);
        reader.readAsDataURL(file);
      },
      tryApplyFile(file, extension) {
        if (file.startsWith('data:application/octet-stream') && extension === 'csv') {
          file = file.replace('data:application/octet-stream', 'data:text/csv')
        }
        this.file = file
      },
      async check() {
        await this.execute({ check: true })
      },
      async execute(opt = {}) {
        let errors = []
        if (!this.selected) {
          errors.push('No process selected')
        }
        if (this.fileRequired && !this.file) {
          errors.push('No file uploaded')
        }
        if (!this.branchNameCanonical) {
          errors.push('Cannot find branchName')
        }
        /* simple CSV check for maitreD dispatch */
        if (this.selected.id === 'dispatch-maitre-import' && this.file.substring(0, 52) !== 'data:text/csv;base64,IkRlbGl2ZXJ5IGN1c3RvbWVycyBsaXN') {
          errors.push('CSV file looks invalid. Did you choose the right one?')
        }
        if (errors.length > 0) {
          toast(errors.join('<br>'), 'warning');
          return;
        }
        let check = opt.check !== undefined ? opt.check : false
        let data = {
          process: this.selected.id,
          branchName: this.branchNameCanonical,
          data: this.fileRequired ? this.fileToUpload : undefined,
          flush: !check,
          check: check,
          logs: check,
        }
        this.$store.commit('showSpinner', true);
        try {
          this.logs = await Core.request('POST', this.selected.api, data);
          setTimeout(() => {
            this.$refs.tabs.setActive(this.$refs.dataTab);
          }, 0);
        } catch (e) {
          let parsed = null;
          try { parsed = JSON.parse(e.response) } catch (f) { }

          if (parsed && parsed.error) {
            toast(parsed.error, 'error')
          } else {
            toast('Unexpected error', 'error')
          }
        }
        this.$store.commit('showSpinner', false);
      },

      // ref: http://stackoverflow.com/a/1293163/2343
      // This will parse a delimited string into an array of
      // arrays. The default delimiter is the comma, but this
      // can be overriden in the second argument.
      CSVToArray(strData, strDelimiter) {
        // Check to see if the delimiter is defined. If not,
        // then default to comma.
        strDelimiter = (strDelimiter || ",");

        // Create a regular expression to parse the CSV values.
        let objPattern = new RegExp(
          (
            // Delimiters.
            "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +

            // Quoted fields.
            "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +

            // Standard fields.
            "([^\"\\" + strDelimiter + "\\r\\n]*))"
          ),
          "gi"
        );

        // Create an array to hold our data. Give the array
        // a default empty first row.
        let arrData = [[]];

        // Create an array to hold our individual pattern
        // matching groups.
        let arrMatches = null;

        // Keep looping over the regular expression matches
        // until we can no longer find a match.
        while (arrMatches = objPattern.exec(strData)) {

          // Get the delimiter that was found.
          let strMatchedDelimiter = arrMatches[1];

          // Check to see if the given delimiter has a length
          // (is not the start of string) and if it matches
          // field delimiter. If id does not, then we know
          // that this delimiter is a row delimiter.
          if (
            strMatchedDelimiter.length &&
            strMatchedDelimiter !== strDelimiter
          ) {
            // Since we have reached a new row of data,
            // add an empty row to our data array.
            arrData.push([]);

          }

          let strMatchedValue;

          // Now that we have our delimiter out of the way,
          // let's check to see which kind of value we
          // captured (quoted or unquoted).
          if (arrMatches[2]) {
            // We found a quoted value. When we capture
            // this value, unescape any double quotes.
            strMatchedValue = arrMatches[2].replace(
              new RegExp("\"\"", "g"),
              "\""
            );

          } else {
            // We found a non-quoted value.
            strMatchedValue = arrMatches[3];
          }

          // Now that we have our value string, let's add
          // it to the data array.
          arrData[arrData.length - 1].push(strMatchedValue);
        }

        // Return the parsed data.
        return (arrData);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .actions {
    text-align: center;
    margin-bottom: 15px;

    :not(:last-child) {
      margin-right: 8px;
    }
  }

  .tab {
    margin-left: 15px;
  }
</style>